import ReviewProfileContent from './ReviewProfileContent'

export default ReviewProfileContent
